/* eslint-disable max-lines-per-function */
import React from "react"
import { AnswerText,
  Bar,
  Container,
  NumberAnsweredText,
  PercentCorrectBar,
  Text,
  TextContent,
  expandX } from "./styled"

const Answer = ({
  answer,
  colors,
  className,
  isCorrect,
  isMobile,
  isRevealed,
  isSelectable,
  numberAnswered,
  onSelect,
  orientation,
  percentAnswered,
}) => {

  const colorState = isRevealed ? (
    isCorrect ? "correct" : "incorrect" 
  ) : "neutral"

  return (
    <Container 
      className={className}
      onClick={isSelectable ? onSelect : null}
    >
      <Bar 
        fillColor={colors[colorState].answerBar}
        isSelectable={isSelectable}
        orientation={orientation} 
        selectedColor={colors.selected.answerBar}
      />

      { isRevealed && (
        <PercentCorrectBar 
          fillColor={colors[colorState].percentCorrectBar}
          orientation={orientation}
          percentFull={percentAnswered} 
        />
      )}

      <TextContent
        fontColor={colors[colorState].font}
        isMobile={isMobile}
        isRevealed={isRevealed}
        orientation={orientation}
      >
        { isRevealed && (
          <NumberAnsweredText
            isMobile={isMobile}
            orientation={orientation}
          >
            { numberAnswered } 
          </NumberAnsweredText> 
        )} 

        <AnswerText 
          answerLength={answer.length}
          isRevealed={isRevealed}
          orientation={orientation}
        >
          { answer }
        </AnswerText>
      </TextContent>

    </Container>
  )
}

export default Answer